module.exports = __webpack_public_path__ + "static/media/ophos-ability.7be57e6c.svg";